import React, { Component } from "react";
import MenuCategoryHOC from "../MenuCategoryHOC";
import RestContextHOC from "../../Contexts/RestContextHOC";
import AnalyticsContextHOC from "../../Contexts/AnalyticsContextHOC";

class MenuCategoryDesktop extends Component {

  constructor(props){
    super(props)
    this.state = {
      visibility:'visible',
      hovered: false
    }
  }

  componentDidMount(){
    this.handleOverflow()
    window.addEventListener('resize',()=>this.handleOverflow())
    this.checkVisibility()
  }

  checkVisibility(){
    let menu_category_id = this.props.category.menu_category_id
    if(this.props.rest.categoryHidden.indexOf(menu_category_id) > -1){
      this.setState({visibility: 'hidden'})
    } else if (this.props.rest.categoryGreyedOut.indexOf(menu_category_id) > -1) {
      this.setState({visibility: 'greyed_out'})
    } else {
      this.setState({visibility: 'visible'})
    }
  }

  componentDidUpdate(prevProps){
    if (this.props.expanded !== prevProps.expanded){
      this.handleOverflow()
    }
    if( 
      (JSON.stringify(prevProps.rest.categoryGreyedOut) !==  
      JSON.stringify(this.props.rest.categoryGreyedOut)) 
      ||
      (JSON.stringify(prevProps.rest.categoryHidden) !==  
      JSON.stringify(this.props.rest.categoryHidden)) 
    ){ 
      this.checkVisibility()
    } 
  }

  handleOverflow(){
    window.setTimeout(()=>{ if (!this.props.isVisible && !this.props.expanded){
      this.props.detectCategoryOverflow()
    }},200)
  }

  getBlackedOutBodyStyle(){
    if(this.state.visibility === 'greyed_out'){
      return {'textDecoration':'line-through'}
    } else if (this.state.visibility === 'hidden'){
      return {display:'none'}
    } else {
      return {}
    }
  }

  getMenuCategorySelectorStyle(){
    let style  = {}
    if (this.state.hovered) {
      style['color'] = this.props.rest.hex_color_secondary
    } else if (this.state.visibility === 'hidden'){
      style['display'] = 'none'
    }
    return style
  }

  isOffScreen(){
    return !this.props.isVisible && !this.props.expanded
  }

  render(){
    const offScreen = this.isOffScreen()
    const isHidden = this.state.visibility === 'hidden'
    const removeFromTabOrder = offScreen || isHidden
    return (
      <button
        type="button"
        className='MenuCategorySelector'
        onClick={() => this.props.scrollToCategory(this.props.category, false, this.props.selectedIdx)}
        style={this.getMenuCategorySelectorStyle()}
        aria-current={this.props.selected ? "true" : undefined}
        aria-hidden={isHidden ? "true" : undefined}
        tabIndex={removeFromTabOrder ? -1 : undefined}
        onMouseEnter={() => this.setState({hovered: true})}
        onMouseLeave={() => this.setState({hovered: false})}
      >
        {this.props.category.image_url && this.state.visibility !== 'hidden' && <img className='MenuCategorySelectorImg' src={this.props.category.image_url} alt='' />}
        <span style={this.getBlackedOutBodyStyle()} className='MenuCategorySelectorBody'>{this.props.category.name}</span>
      </button>
    );
  }
}

export default AnalyticsContextHOC(
  RestContextHOC(MenuCategoryHOC(MenuCategoryDesktop))
);
